var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.011 20.25v-8.678L1 7.723v10.695c0 1.222.611 1.833 1.833 1.833",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.767 11.511l6.234 4.706 6.233-4.706V5.523l-6.233 4.705-6.234-4.705",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.99 20.25v-8.678L23 7.723v10.695c0 1.222-.61 1.833-1.832 1.833",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.845l5.011 3.85v-5.99L4.178 4.3C2.528 3.017 1 4.3 1 5.89",
    fill: "#C5221F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.845l-5.01 3.85v-5.99L19.823 4.3c1.65-1.283 3.178 0 3.178 1.59",
    fill: "#FBBC04"
  })));
}
export default SvgGmail;